import { render, staticRenderFns } from "./UsersInvitationDialogComponent.vue?vue&type=template&id=2ae15c9e&scoped=true&"
import script from "./UsersInvitationDialogComponent.vue?vue&type=script&lang=js&"
export * from "./UsersInvitationDialogComponent.vue?vue&type=script&lang=js&"
import style0 from "./UsersInvitationDialogComponent.vue?vue&type=style&index=0&id=2ae15c9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae15c9e",
  null
  
)

export default component.exports